module.exports = __webpack_public_path__ + "static/img/fail.cac8c337.png";